import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../services/authService';
import { toast } from 'react-toastify';
import { useAuth } from '../../../contexts/AuthContext';

const useInactivityTimer = (timeout = 5 * 60 * 1000) => {
  const navigate = useNavigate();
  const { setAuthenticated, setAdminStatus } = useAuth();

  useEffect(() => {
    let inactivityTimer;

    const resetTimer = () => {
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }

      inactivityTimer = setTimeout(() => {
        logout();
        setAuthenticated(false);
        setAdminStatus(false);
        toast.info('You have been logged out due to inactivity.');
        navigate('/a3-login');
      }, timeout);
    };

    resetTimer();

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    window.resetInactivityTimer = resetTimer;

    return () => {
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }
      
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
      
      delete window.resetInactivityTimer;
    };
  }, [navigate, setAuthenticated, setAdminStatus, timeout]);
};

export default useInactivityTimer;